import { useSearchParams } from 'next/navigation'
import { stringifyUrl } from 'query-string'
import * as React from 'react'

import { useTranslation } from '../../../../../../_providers/TranslationProvider.client'
import { NextLink } from '../../../../../navigation/NextLink'

import { Body, LinkItem, Links, ListWrapper, Title } from './styles'

import type {
  Link,
  ProductCatalogLink,
} from '../../../../../../../__generated__/graphql/catalog/graphql'

// Note: CollectionLink is deprecated.
export type CollectionLinksProps = {
  links: ProductCatalogLink[] | Link[]
  centered?: boolean
}

export const CollectionLinks = ({ links, centered }: CollectionLinksProps) => {
  const {
    detailsSection: { collectionLinksTitle },
  } = useTranslation()
  // plain=true query param is used by iOS app to view webpages within a webview without the website's header/footer
  const plainQueryParamValue = useSearchParams()?.get('plain') ?? undefined

  if (!links.length) return null

  const getItemUrl = (url: string) => {
    const query = { plain: plainQueryParamValue }
    return stringifyUrl({ url, query })
  }

  return (
    <Body $centered={centered}>
      <Title textTransform='uppercase'>{collectionLinksTitle}</Title>
      <Links>
        {links.map(link => (
          <ListWrapper key={link.text}>
            <NextLink href={getItemUrl('url' in link ? link.url : link.href)}>
              <LinkItem>{link.text}</LinkItem>
            </NextLink>
          </ListWrapper>
        ))}
      </Links>
    </Body>
  )
}
